module.exports = __webpack_public_path__ + "img/SWP_Shield_03 (2).f0b24dcb.png";